import { render, staticRenderFns } from "./KbliList.vue?vue&type=template&id=486c312a&"
import script from "./KbliList.vue?vue&type=script&lang=js&"
export * from "./KbliList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports